import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import singleswitch from '../../../assets/switch.png';

const EditMyPrivacyModal = ({ modal, toggle }) => {
    return (
    <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-500">        
        <div className="d-flex pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
            <div className="modal-header">Are you open to job opportunities?</div>
            <div className="v-align f-right" style={{marginLeft:'auto'}}>
                <i className="far fa-question-circle modal-close mg-r-15" ></i>            
                <i className="fas fa-times modal-close" onClick={toggle}></i>
            </div>
        </div>   
        <hr className="mg-r-0"></hr>   
        <div className="modal-block">
            <div className="row ">
                <div className="col-md-5 v-align">
                <img src={singleswitch} style={{height: '30px'}} />      
                <div className="modal-subheader mg-l-10 mg-b-0">On</div>                      
                </div>
                <div className="col-md-7 text-center">
                    <div className="modal-subheader mg-b-0">Your profile will be visible and can be selected by potential recruiters</div>
                    
                </div>
            </div>            
        </div>  
        <hr className="mg-0 "></hr>
            <div className="pd-t-15 pd-b-15 pd-r-20 pd-l-20 box-shadow-top">
            <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>
            </div>        
    </Modal>
)}
export default EditMyPrivacyModal;